import { opentokActions } from '../reducer/actions';

export class ReduxEmitter {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  dispatchAddConnection(payload) {
    this.dispatch(opentokActions.addConnection(payload));
  }

  dispatchRemoveConnection(payload) {
    this.dispatch(opentokActions.removeConnection(payload));
  }

  dispatchUpdateConnection(payload) {
    this.dispatch(opentokActions.updateConnection(payload));
  }

  dispatchAddActiveSpeaker(payload) {
    this.dispatch(opentokActions.addSpeaker(payload));
  }

  dispatchRemoveActiveSpeaker(payload) {
    this.dispatch(opentokActions.removeSpeaker(payload));
  }

  dispatchSetConnectionTime(payload) {
    this.dispatch(opentokActions.setStartCallTime(payload));
  }

  dispatchSetDurationData(payload) {
    this.dispatch(opentokActions.setDurationData(payload));
  }

  dispatchAddVideoWarningId(payload) {
    this.dispatch(opentokActions.addVideoWarningId(payload));
  }

  dispatchRemoveVideoWarningId(payload) {
    this.dispatch(opentokActions.removeVideoWarningId(payload));
  }

  dispatchFindScreenSharing() {
    this.dispatch(opentokActions.findScreenSharing());
  }

  dispatchUpdateInvitations(payload) {
    this.dispatch(opentokActions.updateInvitations(payload));
  }

  dispatchReset() {
    this.dispatch(opentokActions.reset());
  }

  dispatchToggleLoading(flag) {
    this.dispatch(opentokActions.toggleLoading(flag));
  }

  dispatchSetActiveId(id) {
    this.dispatch(opentokActions.setActiveId(id));
  }
}



// WEBPACK FOOTER //
// ./src/redux/opentok/helpers/reduxEmitter.js